import { render } from "./uk4.vue?vue&type=template&id=a260ebfa"
import script from "./uk4.vue?vue&type=script&lang=js"
export * from "./uk4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__